module.exports = __webpack_public_path__ + "img/mlcam_back_front.e2209093.png";